<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت اختصاص دسته های کالا به تامین کنندگان</h3>
                    </div>
                    <div class="card-body">
                        <div class="card-body">
                            <div class="row">
                                <div class="card-header admin-header w-100">

                                    <h5 class="text-accent-light">تامین کنندگان</h5>

                                </div>

                                <div class="col-12 input-group round mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">جستجو</span>
                                    </div>
                                    <input class="form-control" v-model="search" @input="searching()"
                                           placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا آدرس را وارد کنید">
                                </div>
                                <div class="table-responsive">
                                    <div v-if="!isLoading">
                                        <preloader/>
                                    </div>
                                    <div v-else>
                                        <div v-if="mysuppliers.length===0">
                                            <p class="text-center mt-3">هیچ تامین کننده ای ثبت نشده است. برای ثبت روی دکمه + کلیک
                                                کنید</p>

                                        </div>
                                        <div v-else>
                                            <table class="table table-hover table-striped mb-3">
                                                <thead>
                                                <tr>
                                                    <th>کد مشتری</th>
                                                    <th>نام مشتری</th>
                                                    <th class="text-center">عملیات</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="it in mysuppliers">

                                                    <td class="text-nowrap">{{it.customerCode}}</td>
                                                    <td class="text-nowrap">{{it.fullName}}</td>
                                                    <td class="text-center text-nowrap"><i
                                                            class="fa fa-pencil-square-o px-3 clickable"
                                                            style="font-size: larger"
                                                            @click="editCustomerItem(it)"
                                                            title="ویرایش آیتم"></i>

                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal" >
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 >مشخصات تامین کننده</h1>
                    </div>
                    <div class="col-lg-3 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد تامین کننده</span>
                            </div>
                            <input class="form-control" readonly="true" v-model="supplierModel.customerCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام</span>
                            </div>
                            <input class="form-control" readonly="true"  v-model="supplierModel.name">
                        </div>
                    </div>
                    <div class="col-lg-5 mb-3">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام خانوادگی/شرکت</span>
                            </div>
                            <input class="form-control"  readonly="true" v-model="supplierModel.family">
                        </div>
                    </div>
                    <div class="col-lg-7 mb-1">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تلفن همراه</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="tablecustomerphone"
                                       :mode="'create'"
                                       :selected-val="filtercustomerphone"
                                       :header="{multiple: false, label: 'showName'}"
                                       aria-placeholder=""
                                       @onChange="onfilterCustomerPhoneChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-5 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد/شناسه ملی</span>
                            </div>
                            <input class="form-control" readonly="true"  v-model="supplierModel.nationalCode">
                        </div>
                    </div>


                    <div class="row w-100">
                        <h4 class="col-12 text-center">انتخاب دسته بندی کالا</h4>
                        <div class="row mt-3">
                            <div class="col-lg-4 ">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته اصلی کالا</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="maincategorys"
                                               :mode="'create'"
                                               :selected-val="filterMainCategory"
                                               :header="{multiple: false, label: 'categoryName'}"
                                               aria-placeholder="فیلتر براساس دسته کالا"
                                               @onChange="onMainCategoryChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-4 ">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته فرعی کالا</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="categorys"
                                               :mode="'create'"
                                               :selected-val="filterCategory"
                                               :header="{multiple: false, label: 'categoryName'}"
                                               aria-placeholder="فیلتر براساس دسته کالا"
                                               @onChange="onCategoryChange"></vs-select>
                                </div>
                            </div>

                            <td class="text-center text-nowrap">

                                <button class="btn btn-link text-accent-light"
                                        @click="onAddCategoryClicked()"><i class="fa fa-plus"></i>
                                </button>
                            </td>

                            <div class="col-12 overflow-5 m-3 pb-3" style="max-height: 12rem;">
                                <table class="table table-hover table-striped mb-3 ">

                                    <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام دسته اصلی</th>
                                        <th>نام دسته فرعی</th>
                                        <th>عملیات</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="it in categoryToCustomer" v-if="it.categoryId>0">

                                        <td> {{it.row}}</td>
                                        <td> {{it.parentCategoryName}}</td>
                                        <td>{{it.categoryName}}</td>

                                        <td class=" text-nowrap"><i
                                                class="fa fa-trash px-3 clickable"
                                                style="font-size: larger"
                                                @click="deleteCategoryItem(it)"
                                                title="ویرایش آیتم"></i>

                                        </td>

                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row w-100">
                                <h4 class="col-12 text-center">کالا های این دسته</h4>
                            <div class="col-12 overflow-5 m-3 pb-3" style="max-height: 12rem;">
                                <table class="table table-hover table-striped mb-3 ">

                                    <thead>
                                    <tr>

                                        <th class="text-center">ردیف</th>
                                        <th class="text-center">انتخاب</th>
                                        <th class="text-center">کد کالا</th>
                                        <th class="text-center">نام کالا</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="it in productToCustomerList" v-if="it.productId>0">
                                        <td class="text-center">{{it.row}}</td>
                                        <input class="text-center" type="checkbox" v-model="it.isChecked"  >
                                        <td class="text-center"> {{it.productCode}}</td>
                                        <td class="text-center"> {{it.productName}}</td>

                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updateCategoryToCustomer" v-if="cateToCustMode==='edit'">ویرایش اطلاعات
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createCategoryToCustomer" v-else>ثبت اطلاعات
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelCategoryToCustomer">انصراف
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
            </modal>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->

            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Constants from "../../_framework/Constants";

    export default {
        name: "CategoryToSupplier",
        components: {VsSelect, DatePicker},
        data() {
            return {
                showArchive: false,
                isSending: false,
                isLoading: false,
                showNewCategoryToCustomer : false,
                myUsers :[],
                cateToCustMode : "create",
                search: "",

                categoryToCustomer:[{
                    row :"",
                    categoryId:"",
                    parentCategoryId:"",
                    categoryName:"",
                    parentCategoryName :"",
                }],
                customerId :"",
                categoryToCustomerList:[],
                productToCustomerList :[{
                    id :"",
                    row :0,
                    isChecked : false,
                    customerId:"",
                    customersFullName:"",
                    categoryId:"",
                    parentCategoryId:"",
                    categoryName:"",
                    parentCategoryName :"",
                    productId:"",
                    productCode:"",
                    productName:"",
                }],
                productToCustomerModel :{

                    categoryId :"",
                    userId :"",
                    customerId :"",
                    productId :"",
                    companyId :"",
                    isActive :true,
                    activationDate :"",

                    managerId :"",
                },
                productlist :[],
                showNewCustomer : false,
                mysuppliers : [],
                supplierModel: {
                    id: 0,
                    customerCode : "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone : "",
                    address: "",
                    postalCode :"",

                    email : "",
                    birthday :"",
                    nationalCode : "",
                    taxCode : "",
                    companeyId : 0,
                    customerType : 1,

                },

                tablecustomerphone :[],
                filtercustomerphone : "",
                customerPhone :[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                }],
                maincategorys: [],
                filterMainCategory: "",
                categorys: [],
                defualtmainCategoryCode:"",
                filterCategory:"",
                row:0,
                productrow:0,

                dateObj :"",
                currentDate :"",
                recorddate:"",

            }
        },
        mounted() {


            this.getMySupplier();
            this.getMainCategorys();


        },
        methods: {

            onCategoryChange(val) {

                if (val ) {
                    this.filterCategory = val;

                }
            },

            onMainCategoryChange(val) {

                if (val ) {

                    this.filterMainCategory = val;

                    this.getCategorys(val);

                }
            },
            getMainCategorys() {
                new BaseService("category", "/GetMainCategory").getList().then(response => {

                    if (response.data.length > 0) {
                        this.maincategorys = response.data;
                    }
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getCategorys(val) {
                if(val && val.id) {

                    new BaseService("Category", `/GetSecondCategory/${val.id}`).getList().then(response => {

                        this.categorys = response.data;




                    }).catch(error => {

                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onAddCategoryClicked(){

                if(this.filterMainCategory===undefined || this.filterMainCategory===null || this.filterMainCategory==="")
                {
                    Utils.handleErrorWithNotification("لطفا دسته اصلی کالا را انتخاب کنید",this.$noty);
                    return;
                }
                if(this.filterCategory===undefined || this.filterCategory===null || this.filterCategory==="")
                {
                    Utils.handleErrorWithNotification("لطفا دسته فرعی کالا را انتخاب کنید",this.$noty);
                    return;
                }
                let addchk=true ;
                for(let list of this.categoryToCustomer)
                {
                    if(list.categoryId === this.filterCategory.id){
                        addchk=false;
                        break;
                    }
                }
                if(addchk){
                    this.row++;
                    this.categoryToCustomer.push({
                      row:this.row,
                        categoryId:this.filterCategory.id,
                        parentCategoryId:this.filterCategory.parentCategoryId,
                        categoryName:this.filterCategory.categoryName,
                        parentCategoryName :this.filterCategory.parentCategoryName,

                    });
                }
                new BaseService("Product",`/GetProductByCategoryId/${this.filterCategory.id}`).getList().then(response =>{
                    this.productlist=response.data;
                    if(this.productlist.length>0) {
                        addchk=true;
                        for (let list of this.productlist) {
                            for(let prduct of this.productToCustomerList){
                                if(prduct.productId === list.id){
                                    addchk=false;
                                    break;
                                }

                            }
                            if(addchk) {

                                this.productrow++;
                                this.productToCustomerList.push({

                                    row: this.productrow,
                                    isChecked : true,
                                    categoryId: list.categoryId,
                                    parentCategoryId: list.mainCategoryId,
                                    categoryName: list.categoryName,
                                    parentCategoryName: list.parentCategoryName,
                                    productId: list.id,
                                    productCode: list.productCode,
                                    productName: list.productName,
                                });
                            }

                        }
                    }
                    this.filterCategory="";
                    //this.filterMainCategory="";

                }).catch(error => {
                    //this.isSending = true;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    //   this.$refs.insertModal.hideModal();
                });

            },



            getMySupplier() {
                new BaseService("Supplier", "/GetSupplier").getList().then(response => {
                    this.mysuppliers = response.data;
                    this.isLoading = true;
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            deleteCategoryItem(item){
              if(item)
              {
                  if (confirm("با حذف این دسته کلیه کالاهای انتخابی حذف می شوند . آیا از حذف این دسته کالا اطمینان دارید؟")) {

                      let chk=true;
                      let index=0;
                      while(chk) {
                          chk=false;
                          index=0;
                          for (let list of this.productToCustomerList) {
                              if (list.categoryId.toString() === item.categoryId.toString()) {
                                  this.productToCustomerList.splice(index,1);
                                  chk=true;
                                  break;
                              }
                              index++;
                          }
                      }
                      index=0;
                      chk=true;
                      while(chk) {
                          chk = false;
                          index=0;
                          for (let list of this.categoryToCustomer) {
                              if (list.categoryId.toString() === item.categoryId.toString()) {
                                  this.categoryToCustomer.splice(index, 1);
                                  chk = true;
                                  break;
                              }
                              index++;
                          }
                      }


                  }

              }
            },
            editCustomerItem(item) {
                this.showNewCategoryToCustomer = true;
                this.isSending = false;

                this.supplierModel =item;
                this.categoryToCustomer=[{
                    row :"",
                    categoryId:"",
                    parentCategoryId:"",
                    categoryName:"",
                    parentCategoryName :"",
                }];
                this.customerId = item.id;

                this.productToCustomerList =[{
                    id :"",
                    row :0,
                    isChecked : false,
                    customerId:"",
                    customersFullName:"",
                    categoryId:"",
                    parentCategoryId:"",
                    categoryName:"",
                    parentCategoryName :"",
                    productId:"",
                    productCode:"",
                    productName:"",
                }];
                this.getCustomerPhone(item);
                new BaseService("CategoryToSuppliers",`/GetCustomerById/${item.id}`).getList().then(response => {
                    this.categoryToCustomerList = response.data;

                    this.row=0;
                    if (this.categoryToCustomerList.length > 0) {

                        for(let list of this.categoryToCustomerList){
                            let addchk=true;
                            for(let categor of this.categoryToCustomer){
                                if(categor.categoryId===list.categoryId){
                                    addchk=false;
                                    break;
                                }
                            }
                            if(addchk){

                                this.row++;
                                this.categoryToCustomer.push({
                                    row:this.row,
                                    categoryId: list.categoryId,
                                    parentCategoryId : list.parentCategoryId,
                                    categoryName: list.categoryName,
                                    parentCategoryName : list.parentCategoryName,
                                });
                            }
                        }
                        for(let list of this.categoryToCustomer){
                            if(list.categoryId>0) {

                                new BaseService("Product", `/GetProductByCategoryId/${list.categoryId}`).getList().then(response => {
                                    this.productlist = response.data;
                                    let addchk=false;
                                    if (this.productlist.length > 0) {
                                        this.productrow=0;
                                        for (let list of this.productlist) {

                                           addchk=false;
                                            for (let prduct of this.categoryToCustomerList) {
                                                if (prduct.productId.toString() === list.id.toString()) {
                                                    addchk = true;
                                                    break;
                                                }
                                            }

                                            this.productrow++;
                                            this.productToCustomerList.push({

                                                row: this.productrow,
                                                isChecked : addchk,
                                                categoryId: list.categoryId,
                                                parentCategoryId: list.mainCategoryId,
                                                categoryName: list.categoryName,
                                                parentCategoryName: list.parentCategoryName,
                                                productId: list.id,
                                                productCode: list.productCode,
                                                productName: list.productName,
                                            });

                                        }
                                    }

                                }).catch(error => {
                                    //this.isSending = true;
                                    Utils.handleErrorWithNotification(error.data, this.$noty);
                                    //   this.$refs.insertModal.hideModal();
                                });
                                break;
                            }
                        }
                    }
                }).catch(error => {
                    //this.isSending = true;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                 //   this.$refs.insertModal.hideModal();
                });
                this.filterCategory = "";
                this.$refs.insertModal.showModal();
            },

            getCustomerPhone(val){
                if(val){

                new BaseService("customerPhone", `/GetCustomerPhoneByCostumerId/${val.id}`).getList().then(response => {
                    this.customerPhone = response.data ;
                    if(this.customerPhone.length>0){
                        for(let customer of this.customerPhone)
                        {
                            customer.showName =customer.departmentName +" - "+customer.customeremployeeFullName +" - "+customer.cellPhoneNumber;
                            this.tablecustomerphone.push(customer.showName);
                        }
                        this.filtercustomerphone = this.tablecustomerphone[0];
                    }

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                }
            },

            createCategoryToCustomer(){
                this.isSending=true;

                if(this.productToCustomerList.length<=1){
                    Utils.handleErrorWithNotification("هیچ کالایی انتخاب نشده است",this.$noty);
                    this.isSending=false;
                    return;
                }

                if(this.categoryToCustomer.length===0){
                    Utils.handleErrorWithNotification("هیچ دسته بندی انتخاب نشده است",this.$noty);
                    this.isSending=false;
                    return;
                }
                let addchk=false;
                for(let list of this.productToCustomerList){
                    if(list.isChecked===true){
                        addchk=true;
                        break;
                    }
                }
                if(addchk===false){
                    Utils.handleErrorWithNotification("هیچ کدام از کالا انتخاب نشده اند . لطفا حداقل یک کالا را انتخاب کنید",this.$noty);
                    this.isSending=false;
                    return;
                }

                var productsCategoryToSupplierList = [];
                this.dateObj = new Date().toJSON();
                this.currentDate = this.gregorianToJalali(this.dateObj, false);
                this.recorddate = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                for (let pr of this.productToCustomerList) {
                    if (pr.productId > 0 && pr.isChecked) {
                        this.productToCustomerModel.categoryId =pr.categoryId;
                        this.productToCustomerModel.userId ="";
                        this.productToCustomerModel.customerId= this.customerId;
                        this.productToCustomerModel.productId =pr.productId;
                        this.productToCustomerModel.companyId =0;
                        this.productToCustomerModel.isActive =true;
                        this.productToCustomerModel.activationDate =this.dateObj;

                        this.productToCustomerModel.managerId ="";

                        productsCategoryToSupplierList.push(this.productToCustomerModel);
                        this.productToCustomerModel ={

                            categoryId :"",
                            userId :"",
                            customerId :"",
                            productId :"",
                            companyId :"",
                            isActive :true,
                            activationDate :"",
                            deActivationDate :"",
                            managerId :"",

                        };
                    }
                }

                var model = {
                    categoryToUseresList : productsCategoryToSupplierList
                };

                new BaseService("CategoryToSuppliers", "/CreateCategoryToSupplierList").create(model).then(response => {
                    this.$noty.success("کالا ها با موفقیت به تامین کننده اختصاص یافت");

                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },

            updateCategoryToCustomer() {
                this.isSending = true;





            },

            cancelCategoryToCustomer() {

                this.isSending=true;
                this.$refs.insertModal.hideModal();

            },

            searching() {
                if (this.search.length > 1) {
                    this.isLoading = false;
                    new BaseService("Supplier", `/SearchSupplier/${this.search}`).getList().then(response => {
                        this.mysuppliers = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {

                }
            },




            onfilterCustomerPhoneChange(val){
                if (val && val) {

                    this.filtercustomerphone = val;

                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>